module.exports = __webpack_public_path__ + "img/21.d61eddb3.png";